import userProfile from './slices';

const {
  resetUserProfile,
  requestUser,
  receiveUserPrivilege,
  updateUserPrivilege,
  updateUser,
  removeChannelFromUser,
  addChannelToUser,
} = userProfile.actions;

export default {
  resetUserProfile,
  requestUser,
  receiveUserPrivilege,
  updateUserPrivilege,
  updateUser,
  removeChannelFromUser,
  addChannelToUser,
};
